export enum LoginResult {
  Success = 'success',
  IncorrectDetails = 'incorrect_details',
  Redirect = 'redirect',
  NoAccess = 'no_access',
  NoToken = 'no_token',
  NoOtp = 'no_otp',
  Denied = 'denied',
}
